<div class="page">
  <div class="page__inner">
    <hrra-status-message
      [heading]="'label.Thanks' | translate"
      [message]="'message.UnsubscribeCompleted' | translate"
      [actionLabel]="'label.SubscribeAgain' | translate"
      (action)="onActivateEditMode()"
    ></hrra-status-message>
  </div>
</div>
